export default ({driver: {address_state = ''} = {}} = {}) => address_state;
